<template>
  <div class="wishDetail">
    <div class="oItem">
      <div class="oItem-head">
        <div class="oItem-headName">
          <div class="oItem-avatar">
            <img
              :src="
                oItemDetail.avatar
                  ? oItemDetail.avatar
                  : require('@/assets/img/default_avatar.png')
              "
              alt=""
            />
          </div>
          <div class="oItem-wrap">
            <div class="oItem-tl oItem-name">
              {{
                oItemDetail.userName ? formatStrFunc(oItemDetail.userName) : ""
              }}
            </div>
            <div class="oItem-t">
              <div class="oItem-tr oItem-time">
                {{ oItemDetail.insertTime }}
              </div>
            </div>
          </div>
          <div class="oItem-icon" v-if="getImgUrl(oItemDetail)">
            <img
              :src="require(`@/assets/img/${getImgUrl(oItemDetail)}.png`)"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="oItem-b">
        <div class="oitem-b_tag">
          <span v-show="getStatus(oItemDetail)">
            #{{ getStatus(oItemDetail) }}#
          </span>
        </div>
        <div class="oItem-b_text">
          <span>{{ oItemDetail.proposalContent }}</span>
        </div>
      </div>
    </div>
    <div class="img" v-if="oItemDetail.proposalPic">
      <img :src="oItemDetail.proposalPic" alt="" />
    </div>
  </div>
</template>

<script>
import { wishDetailUrl } from "./api.js";
import { getOption, formatStr } from "@/utils/utils.js";
import { createType } from "./map.js";
import { gloabalCount } from "@/utils/common.js";
var moment = require("moment");
export default {
  name: "wishDetail",
  data() {
    return {
      oItemDetail: {},
      id: "",
    };
  },
  computed: {
    communityId() {
      return this.$store.state.communityId;
    },
  },
  mounted() {
    this.getWishDetail();
    gloabalCount(this.id, 14, 1);
  },
  created() {
    this.id = this.$route.query.id;
  },

  methods: {
    getImgUrl(item) {
      const imgUrlMap = [
        { key: 1, value: "out" },
        { key: 2, value: "reject" },
        { key: 0, value: "waitVerify" },
      ];
      if (item.auditStatus || item.auditStatus == 0) {
        return getOption(item.auditStatus, imgUrlMap, "key").value;
      } else {
        return "";
      }
    },
    formatStrFunc(str) {
      if (str) {
        return formatStr(str);
      }
    },
    getStatus(item) {
      if (item.proposalType) {
        return getOption(item.proposalType, createType, "key").value;
      } else {
        return "";
      }
    },
    getWishDetail() {
      let params = {
        id: this.id,
      };
      this.$axios.get(`${wishDetailUrl}`, { params }).then((res) => {
        if (res.code === 200) {
          this.oItemDetail = res.data;
          if (this.oItemDetail.avatar) {
            this.oItemDetail.avatar = this.$handleImg(
              80,
              80,
              this.oItemDetail.avatar
            );
          }
          if (
            this.oItemDetail.proposalPic &&
            this.oItemDetail.proposalPic.length > 0
          ) {
            this.oItemDetail.proposalPic = this.$handleImg(
              (document.body.clientWidth - 80) * 2,
              (document.body.clientWidth - 80) * 2,
              this.oItemDetail.proposalPic
            );
          }
        } else {
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.wishDetail {
  .oItem {
    background: #fff;
    padding: 32px;
    .oItem-head {
      display: flex;
      justify-content: space-between;
      font-weight: bold;
      margin-bottom: 10px;
      align-items: center;
      width: 100%;
      .oItem-avatar {
        width: 72px;
        height: 72px;
        img {
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }
      .oItem-headName {
        width: 100%;
        display: flex;
        align-items: center;
        position: relative;
        .oItem-wrap {
          flex: 1;
          padding: 0 0 0 16px;
          .oItem-name {
            font-size: 28px;
            font-weight: bold;
            color: #333333;
            line-height: 40px;
          }
          .oItem-t {
            margin-top: 4px;
            font-size: 24px;
            font-weight: 400;
            color: #97999b;
            line-height: 36px;
            .oItem-time {
              font-size: 28px !important;
              font-weight: normal !important;
              color: #999999;
            }
          }
        }
        .oItem-icon {
          position: absolute;
          right: 0;
          top: -32px;
          img {
            height: 164px;
          }
        }
      }
    }
    .oItem-b {
      font-size: 32px;
      line-height: 44px;
      .oitem-b_tag {
        font-size: 32px;
        font-weight: 400;
        color: #fe6f16;
        margin-top: 16px;
      }
      .oItem-b_text {
        font-size: 32px;
        font-weight: 400;
        color: #333333;
        margin-top: 8px;
      }
    }
  }
  .img {
    padding: 0px 40px;
    /*height: 400px;*/
    img {
      width: 100%;
      height: 100%;
      border-radius: 10px;
    }
  }
}
</style>
